import apiClient from "./api";

export interface DocumentoStatus {
  status: "nao_enviado" | "pendente" | "aprovado" | "reprovado";
  aprovacao?: {
    id: number;
    status: string;
    aprovado_por: string | null;
    aprovado_em: string | null;
    observacoes: string | null;
    created_at: string;
    updated_at: string;
  };
}

export interface StatusDocumentosResponse {
  success: boolean;
  status: {
    todos_aprovados: boolean;
    algum_reprovado: boolean;
    pendentes: boolean;
    pode_acessar_editais: boolean;
    documentos: {
      rg_cpf: DocumentoStatus;
      formacao: DocumentoStatus;
      residencia: DocumentoStatus;
    };
  };
}

export interface ReenviarDocumentoPayload {
  documentoTipo: "rg_cpf" | "formacao" | "residencia";
  arquivo: File;
}

export const proponenteService = {
  async getStatusDocumentos(): Promise<StatusDocumentosResponse> {
    const response = await apiClient.get<StatusDocumentosResponse>(
      "/api/v1/proponentes/status-documentos"
    );
    return response.data;
  },

  async reenviarDocumento(
    payload: ReenviarDocumentoPayload
  ): Promise<{ success: boolean; message: string }> {
    const formData = new FormData();
    formData.append("documentoTipo", payload.documentoTipo);
    formData.append("arquivo", payload.arquivo);

    const response = await apiClient.post(
      "/api/v1/proponentes/reenviar-documento",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },
};
